const state = {
    secret: '',
    qrCode: '',
    activated: '',
};

const getters = {
    getSecret(state) {
        return state.secret;
    },
    getQrCode(state) {
        return state.qrCode;
    },
    getActivated(state) {
        return state.activated;
    }
};

const mutations = {
    setState(state, payload) {
        state.secret = payload.secret
        state.qrCode = payload.qrCode
        state.activated = payload.activated
    },
    setActivated(state, bool) {
        state.activated = bool;
    },
};

const actions = {
};

export default {
    state,
    getters,
    mutations,
    actions
}
